// Escuchar en el documento completo para sobrevivir reemplazos del DOM
document.addEventListener('change', function(e) {
  var select = e.target;
  if (!select || select.tagName !== 'SELECT') return;
  if (!select.name || !select.name.toLowerCase().includes('café')) return;

  var opt = select.options[select.selectedIndex];
  if (!opt) return;

  var mediaImage = opt.getAttribute('data-media-image');
  if (!mediaImage) return;

  var filename = mediaImage.split('/').pop().split('?')[0].toLowerCase();
  
  var thumbs = document.querySelectorAll('#thumbnail-carousel li.splide__slide:not(.splide__slide--clone)');
  var targetIndex = -1;
  
  thumbs.forEach(function(thumb, i) {
    var img = thumb.querySelector('img');
    if (img) {
      var thumbFile = img.src.split('/').pop().split('?')[0].toLowerCase();
      if (thumbFile === filename) targetIndex = i;
    }
  });

  console.log('Variante:', opt.value, '| Archivo:', filename, '| Índice:', targetIndex);

  if (targetIndex >= 0) {
    setTimeout(function() {
      var thumbs2 = document.querySelectorAll('#thumbnail-carousel li.splide__slide:not(.splide__slide--clone)');
      if (thumbs2[targetIndex]) {
        thumbs2[targetIndex].dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
      }
    }, 300);
  }
}, true);



